export { default } from '../../theme/ThemeQueryEffect';
